import AXIOS from "axios";
import { config } from "@/constants";

export const axios = AXIOS.create({
  baseURL: config.baseURL,
});

export const call = (params) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    if (!params.headers) params.headers = {};
    if (token) params.headers.Authorization = `Bearer ${token}`;

    return axios(params);
  };
};
